export const version = "abi/5.4.1";
//# sourceMappingURL=_version.js.map